import { defineComponent as _defineComponent } from 'vue'
import { cloneDeep } from 'lodash'
import { computed, onMounted, ref } from 'vue'
import draggable from 'vuedraggable'

import LButton from '@/components/core/Button.vue'
import { tripModule } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageFeatureExpansion',
  setup(__props) {

const trip = computed(() => {
  return tripModule.trip
})
const dashboardFeatures = ref(cloneDeep(tripModule.defaultDashboardFeatures))

function setDashboard() {
  if (!trip.value) {
    return
  }
  tripModule.setDashboardFeatures(cloneDeep(dashboardFeatures.value))

  localStorage.setItem(
    `kLambusDashboardOrder-${trip.value.id}`,
    JSON.stringify(dashboardFeatures.value),
  )
}

onMounted(() => {
  if (!trip.value) {
    return
  }

  const dashboardOrder = localStorage.getItem(
    `kLambusDashboardOrder-${trip.value.id}`,
  )

  if (dashboardOrder) {
    tripModule.setDashboardFeatures(JSON.parse(dashboardOrder))
    dashboardFeatures.value = JSON.parse(dashboardOrder)
  }
})

function toggleFeatureVisibility(featureName: string) {
  const foundFeature = dashboardFeatures.value.find(
    (element) => element.name === featureName,
  )
  if (foundFeature) {
    foundFeature.isDisplayed = !foundFeature.isDisplayed
  }
}

function resetDashboardOrder() {
  tripModule.resetDashboardOrder()
  dashboardFeatures.value = cloneDeep(tripModule.defaultDashboardFeatures)
}

return { __sfc: true,trip, dashboardFeatures, setDashboard, toggleFeatureVisibility, resetDashboardOrder, draggable, LButton }
}

})